// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-thumbnail ion-icon {
  font-size: 24px;
}
ion-thumbnail {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(var(--ion-color-medium-rgb), 0.08);
  border-radius: 100px;
  flex-shrink: 0;
}

ion-item-option {
  font-size: 35px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

ion-icon {
  transition: 0.2s linear;
}

.icon-online {
  color: var(--ion-color-medium);
}

.icon-offline {
  color: #ffffff;
}

.thumbnail-online {
  background-color: rgba(var(--ion-color-medium-rgb), 0.08);
}

.thumbnail-offline {
  background-color: var(--ion-color-dark);
}

ion-label {
  margin: 8px;
}

ion-item::part(native) {
  padding-inline-start: 0;
}

@media screen and (min-width: 500px) {
  ion-thumbnail ion-icon {
    font-size: 30px;
  }
  ion-thumbnail {
    width: 56px;
    height: 56px;
  }
  ion-item::part(native) {
    padding-inline-start: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/general components/supervision/supervision.component.scss","webpack://./src/components/general%20components/supervision/supervision.component.scss"],"names":[],"mappings":"AACE;EACE,eAAA;ACAJ;ADFA;EAKE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yDAAA;EACA,oBAAA;EACA,cAAA;ACAF;;ADGA;EACE,eAAA;EACA,gDAAA;ACAF;;ADGA;EACE,uBAAA;ACAF;;ADGA;EACE,8BAAA;ACAF;;ADGA;EACE,cAAA;ACAF;;ADGA;EACE,yDAAA;ACAF;;ADGA;EACE,uCAAA;ACAF;;ADGA;EACE,WAAA;ACAF;;ADGA;EACE,uBAAA;ACAF;;ADGA;EAEI;IACE,eAAA;ECDJ;EDDA;IAKE,WAAA;IACA,YAAA;ECDF;EDIA;IACE,0BAAA;ECFF;AACF","sourcesContent":["ion-thumbnail {\n  ion-icon {\n    font-size: 24px;\n  }\n\n  width: 48px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(var(--ion-color-medium-rgb), 0.08);\n  border-radius: 100px;\n  flex-shrink: 0;\n}\n\nion-item-option {\n  font-size: 35px;\n  border-right: 1px solid rgb(255, 255, 255, 0.2);\n}\n\nion-icon {\n  transition: 0.2s linear;\n}\n\n.icon-online {\n  color: var(--ion-color-medium);\n}\n\n.icon-offline {\n  color: #ffffff;\n}\n\n.thumbnail-online {\n  background-color: rgba(var(--ion-color-medium-rgb), 0.08);\n}\n\n.thumbnail-offline {\n  background-color: var(--ion-color-dark);\n}\n\nion-label {\n  margin: 8px;\n}\n\nion-item::part(native) {\n  padding-inline-start: 0;\n}\n\n@media screen and (min-width: 500px) {\n  ion-thumbnail {\n    ion-icon {\n      font-size: 30px;\n    }\n\n    width: 56px;\n    height: 56px;\n  }\n\n  ion-item::part(native) {\n    padding-inline-start: 16px;\n  }\n\n}","ion-thumbnail ion-icon {\n  font-size: 24px;\n}\nion-thumbnail {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(var(--ion-color-medium-rgb), 0.08);\n  border-radius: 100px;\n  flex-shrink: 0;\n}\n\nion-item-option {\n  font-size: 35px;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n}\n\nion-icon {\n  transition: 0.2s linear;\n}\n\n.icon-online {\n  color: var(--ion-color-medium);\n}\n\n.icon-offline {\n  color: #ffffff;\n}\n\n.thumbnail-online {\n  background-color: rgba(var(--ion-color-medium-rgb), 0.08);\n}\n\n.thumbnail-offline {\n  background-color: var(--ion-color-dark);\n}\n\nion-label {\n  margin: 8px;\n}\n\nion-item::part(native) {\n  padding-inline-start: 0;\n}\n\n@media screen and (min-width: 500px) {\n  ion-thumbnail ion-icon {\n    font-size: 30px;\n  }\n  ion-thumbnail {\n    width: 56px;\n    height: 56px;\n  }\n  ion-item::part(native) {\n    padding-inline-start: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
